/*
 * ROMO · Sistema de movimiento (Fase 2)
 * Un solo sistema, no una coleccion de efectos:
 *   - Todo entra desde ABAJO, 40px. Duracion 0.6-0.9s. Easing power3.out.
 *   - Respeta prefers-reduced-motion (gsap.matchMedia).
 *   - Se reinicia en shopify:section:load / :unload (editor de temas).
 *   - ScrollTrigger.refresh() cuando terminan de cargar imagenes y fuentes.
 * Comportamientos (opt-in por atributo):
 *   [data-romo-reveal]           -> revelado al hacer scroll (desde abajo 40px)
 *   [data-romo-reveal][stagger]  -> revela sus hijos en cascada
 *   [data-romo-count="1234"]     -> contador que sube desde 0 al entrar en pantalla
 *   [data-romo-accordion]        -> acordeon con apertura/cierre suave
 * (Las marquesinas son CSS puro y ya respetan reduced-motion en su hoja.)
 */
(function () {
  'use strict';

  var gsap = window.gsap;
  if (!gsap) return; // si por lo que sea no cargo GSAP, la web sigue funcionando sin animar
  var ScrollTrigger = window.ScrollTrigger;
  if (ScrollTrigger) gsap.registerPlugin(ScrollTrigger);

  var DUR = 0.8;          // dentro del rango 0.6-0.9
  var EASE = 'power3.out'; // prohibido bounce/elastic
  var DIST = 40;           // una sola distancia en toda la web

  var mm = null;

  /* ---------- Revelados al hacer scroll ---------- */
  function buildReveals() {
    gsap.utils.toArray('[data-romo-reveal]').forEach(function (el) {
      var stagger = el.hasAttribute('data-romo-stagger');
      var targets = stagger ? el.children : el;
      gsap.from(targets, {
        y: DIST,
        opacity: 0,
        duration: DUR,
        ease: EASE,
        stagger: stagger ? 0.09 : 0,
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          once: true
        }
      });
    });

    // Productos de la coleccion destacada (Dawn): revelado en cascada, sin tocar su seccion
    if (ScrollTrigger) {
      var grid = document.querySelector('#shopify-section-featured_collection .product-grid, #shopify-section-featured_collection ul.grid');
      if (grid && grid.children.length) {
        gsap.from(grid.children, {
          y: DIST,
          opacity: 0,
          duration: DUR,
          ease: EASE,
          stagger: 0.09,
          scrollTrigger: { trigger: grid, start: 'top 85%', once: true }
        });
      }
    }
  }

  /* ---------- Contadores ---------- */
  function formatNumber(value, el) {
    var decimals = parseInt(el.getAttribute('data-romo-decimals') || '0', 10);
    var thousands = el.getAttribute('data-romo-thousands');
    if (thousands === null) thousands = '.';
    var decimalSep = el.getAttribute('data-romo-decimal') || ',';
    var prefix = el.getAttribute('data-romo-prefix') || '';
    var suffix = el.getAttribute('data-romo-suffix') || '';

    var fixed = value.toFixed(decimals);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return prefix + parts.join(decimalSep) + suffix;
  }

  function buildCounters(motionOK) {
    gsap.utils.toArray('[data-romo-count]').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-romo-count')) || 0;
      if (!motionOK || !ScrollTrigger) {
        el.textContent = formatNumber(target, el); // sin movimiento: valor final directo
        return;
      }
      var proxy = { v: 0 };
      el.textContent = formatNumber(0, el);
      ScrollTrigger.create({
        trigger: el,
        start: 'top 85%',
        once: true,
        onEnter: function () {
          gsap.to(proxy, {
            v: target,
            duration: 1.4,
            ease: 'power2.out',
            onUpdate: function () { el.textContent = formatNumber(proxy.v, el); }
          });
        }
      });
    });
  }

  /* ---------- Acordeon suave ---------- */
  var accHandlers = [];
  function buildAccordions(motionOK) {
    gsap.utils.toArray('[data-romo-accordion] details').forEach(function (details) {
      var content = details.querySelector('[data-romo-acc-content]');
      var summary = details.querySelector('summary');
      if (!content || !summary) return;

      if (!motionOK) return; // reduced-motion: <details> nativo, abre/cierra al instante

      var onClick = function (e) {
        e.preventDefault();
        if (details.open) {
          gsap.to(content, {
            height: 0, opacity: 0, duration: 0.4, ease: 'power2.inOut',
            onComplete: function () { details.open = false; gsap.set(content, { clearProps: 'height,opacity' }); }
          });
        } else {
          details.open = true;
          gsap.set(content, { height: 'auto', opacity: 1 });
          gsap.from(content, { height: 0, opacity: 0, duration: 0.45, ease: EASE });
        }
      };
      summary.addEventListener('click', onClick);
      accHandlers.push({ summary: summary, fn: onClick });
    });
  }
  function clearAccordions() {
    accHandlers.forEach(function (h) { h.summary.removeEventListener('click', h.fn); });
    accHandlers = [];
  }

  /* ---------- Texto revelado por lineas (SplitText) ---------- */
  var splits = [];
  function buildLines() {
    if (!window.SplitText) return;
    gsap.utils.toArray('[data-romo-lines]').forEach(function (el) {
      var split = new SplitText(el, { type: 'lines', linesClass: 'romo-line' });
      splits.push(split);
      gsap.from(split.lines, {
        y: DIST,
        opacity: 0,
        duration: DUR,
        ease: EASE,
        stagger: 0.12,
        scrollTrigger: { trigger: el, start: 'top 85%', once: true }
      });
    });
  }
  function clearLines() {
    splits.forEach(function (s) { try { s.revert(); } catch (e) {} });
    splits = [];
  }

  /* ---------- Videos UGC: reproducir solo en pantalla ---------- */
  var videoObservers = [];
  function setupVideos(motionOK) {
    if (!('IntersectionObserver' in window)) return;
    gsap.utils.toArray('[data-romo-autoplay]').forEach(function (v) {
      v.muted = true; // obligatorio para autoplay
      if (!motionOK) return; // reduced-motion: se queda en el poster, no arranca
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.35 });
      io.observe(v);
      videoObservers.push(io);
    });
  }
  function clearVideos() {
    videoObservers.forEach(function (io) { io.disconnect(); });
    videoObservers = [];
  }

  /* ---------- Seccion estrella OFF -> ROMO -> ON (premium) ---------- */
  function starParts(stage) {
    return {
      on: stage.querySelector('[data-star-on]'),
      onimg: stage.querySelector('[data-star-onimg]'),
      halo: stage.querySelector('[data-star-halo]'),
      can: stage.querySelector('[data-star-can]'),
      wOff: stage.querySelector('[data-word-off]'),
      wRomo: stage.querySelector('[data-word-romo]'),
      wOn: stage.querySelector('[data-word-on]')
    };
  }
  function starSet(t, v) { if (t) gsap.set(t, v); }
  function buildStar() {
    if (!ScrollTrigger) return;
    gsap.utils.toArray('[data-romo-star]').forEach(function (stage) {
      var p = starParts(stage);
      if (!p.can) return;
      // Estado inicial = OFF (partiendo del reposo, que es ON)
      starSet(p.on, { autoAlpha: 0 });
      starSet(p.onimg, { autoAlpha: 0 });
      starSet(p.halo, { autoAlpha: 0.15, scale: 0.85 });
      starSet(p.can, { autoAlpha: 0.55, y: 24, filter: 'grayscale(1) brightness(0.62)' });
      starSet(p.wOff, { autoAlpha: 1 });
      starSet(p.wRomo, { autoAlpha: 0 });
      starSet(p.wOn, { autoAlpha: 0 });

      var desktop = window.matchMedia('(min-width: 750px)').matches;
      var tl = gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: desktop
          ? { trigger: stage, start: 'top top', end: '+=220%', pin: true, scrub: 1, anticipatePin: 1 }
          : { trigger: stage, start: 'top 68%', once: true }
      });

      if (desktop) {
        if (p.wOff) tl.to(p.wOff, { autoAlpha: 0, duration: 0.1 }, 0.24);
        tl.to(p.can, { autoAlpha: 1, y: 0, filter: 'grayscale(0) brightness(1)', duration: 0.28 }, 0.22);
        if (p.halo) tl.to(p.halo, { autoAlpha: 0.95, scale: 1.06, duration: 0.5 }, 0.30);
        if (p.wRomo) tl.to(p.wRomo, { autoAlpha: 1, duration: 0.1 }, 0.32).to(p.wRomo, { autoAlpha: 0, duration: 0.1 }, 0.58);
        tl.to(p.on, { autoAlpha: 1, duration: 0.2 }, 0.56);
        if (p.onimg) tl.to(p.onimg, { autoAlpha: 1, duration: 0.2 }, 0.56);
        if (p.wOn) tl.to(p.wOn, { autoAlpha: 1, duration: 0.12 }, 0.66);
      } else {
        tl.to(p.can, { autoAlpha: 1, y: 0, filter: 'grayscale(0) brightness(1)', duration: 0.7, ease: EASE });
        if (p.halo) tl.to(p.halo, { autoAlpha: 0.95, scale: 1.06, duration: 0.7 }, '<');
        var outs = [p.wOff, p.wRomo].filter(Boolean);
        if (outs.length) tl.to(outs, { autoAlpha: 0, duration: 0.3 }, '<');
        tl.to(p.on, { autoAlpha: 1, duration: 0.7 }, '-=0.2');
        if (p.onimg) tl.to(p.onimg, { autoAlpha: 1, duration: 0.7 }, '<');
        if (p.wOn) tl.to(p.wOn, { autoAlpha: 1, duration: 0.4 }, '<');
      }
    });
  }
  function setStarFinal() {
    // reduced-motion: estado final ON, sin animar
    gsap.utils.toArray('[data-romo-star]').forEach(function (stage) {
      var p = starParts(stage);
      if (!p.can) return;
      starSet(p.on, { autoAlpha: 1 });
      starSet(p.onimg, { autoAlpha: 1 });
      starSet(p.halo, { autoAlpha: 0.95, scale: 1.05 });
      starSet(p.can, { autoAlpha: 1, y: 0, filter: 'none' });
      starSet(p.wOff, { autoAlpha: 0 });
      starSet(p.wRomo, { autoAlpha: 0 });
      starSet(p.wOn, { autoAlpha: 1 });
    });
  }

  /* ---------- Barra de progreso (Crazy Goals) ---------- */
  function fmtThousands(n) {
    return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  function buildProgress(motionOK) {
    gsap.utils.toArray('[data-romo-progress]').forEach(function (el) {
      var fill = el.querySelector('.cg-prog__fill');
      var cur = el.querySelector('.cg-prog__cur');
      var goalEl = el.querySelector('.cg-prog__goal');
      var pct = parseFloat(el.getAttribute('data-pct')) || 0;
      var curVal = cur ? (parseFloat(cur.getAttribute('data-count')) || 0) : 0;
      var goalVal = goalEl ? (parseFloat(goalEl.getAttribute('data-goal')) || 0) : 0;
      var unit = goalEl ? (goalEl.getAttribute('data-unit') || '') : '';
      if (goalEl) goalEl.textContent = fmtThousands(goalVal) + (unit ? ' ' + unit : '');

      if (!motionOK || !ScrollTrigger) {
        if (fill) fill.style.width = pct + '%';
        if (cur) cur.textContent = fmtThousands(curVal);
        return;
      }
      if (fill) fill.style.width = '0%';
      if (cur) cur.textContent = fmtThousands(0);
      ScrollTrigger.create({
        trigger: el,
        start: 'top 85%',
        once: true,
        onEnter: function () {
          if (fill) gsap.to(fill, { width: pct + '%', duration: 1.5, ease: 'power2.out' });
          var proxy = { v: 0 };
          gsap.to(proxy, {
            v: curVal, duration: 1.7, ease: 'power2.out',
            onUpdate: function () { if (cur) cur.textContent = fmtThousands(proxy.v); }
          });
        }
      });
    });
  }

  /* ---------- CTA Variety Pack: la imagen cambia de sabor al hacer scroll ---------- */
  var flavorSwaps = [];
  function clamp01(v) { return Math.max(0, Math.min(1, v)); }
  function buildFlavorSwap(motionOK) {
    gsap.utils.toArray('[data-romo-flavorswap]').forEach(function (media) {
      var flavors = [].slice.call(media.querySelectorAll('.cta__flavor'));
      if (!flavors.length) return;
      var section = media.closest('section') || media;
      var dots = section.querySelectorAll('[data-romo-flavordots] i');

      // reduced-motion o un solo sabor: muestra el primero fijo
      if (!motionOK || flavors.length < 2) {
        flavors.forEach(function (f, i) { f.style.opacity = i === 0 ? 1 : 0; });
        if (dots.length) dots[0].classList.add('on');
        return;
      }

      // centros repartidos: 2 sabores -> .3/.7, 3 -> .22/.5/.78, etc.
      var n = flavors.length;
      var centers = flavors.map(function (_, i) { return (i + 1) / (n + 1); });
      var windowSize = 1 / (n + 1) + 0.08; // ancho del crossfade

      var onScroll = function () {
        var r = media.getBoundingClientRect();
        var vh = window.innerHeight;
        var p = clamp01((vh - r.top) / (vh + r.height));
        var active = 0, best = 9;
        flavors.forEach(function (f, i) {
          var d = Math.abs(p - centers[i]);
          var o = clamp01(1 - d / windowSize);
          f.style.opacity = o;
          f.style.transform = 'translateY(' + ((p - centers[i]) * 34) + 'px) scale(' + (0.95 + o * 0.05) + ')';
          if (d < best) { best = d; active = i; }
        });
        if (dots.length) dots.forEach(function (dt, i) { dt.classList.toggle('on', i === active); });
      };

      document.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
      flavorSwaps.push(onScroll);
    });
  }
  function clearFlavorSwaps() {
    flavorSwaps.forEach(function (fn) {
      document.removeEventListener('scroll', fn);
      window.removeEventListener('resize', fn);
    });
    flavorSwaps = [];
  }

  /* ---------- Hero: las latas crecen al hacer scroll ---------- */
  function buildHeroScale() {
    if (!ScrollTrigger) return;
    gsap.utils.toArray('[data-romo-heroscale]').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-romo-heroscale')) || 1;
      if (target <= 1.001) return;
      var trig = el.closest('section') || el;
      gsap.fromTo(el, { scale: 1 }, {
        scale: target, ease: 'none', transformOrigin: '50% 50%',
        scrollTrigger: { trigger: trig, start: 'top top', end: 'bottom top', scrub: true }
      });
    });
  }

  /* ---------- Init / re-init ---------- */
  function init() {
    mm = gsap.matchMedia();
    mm.add('(prefers-reduced-motion: no-preference)', function () {
      buildReveals();
      buildCounters(true);
      buildAccordions(true);
      buildLines();
      setupVideos(true);
      buildStar();
      buildHeroScale();
      buildFlavorSwap(true);
      buildProgress(true);
    });
    mm.add('(prefers-reduced-motion: reduce)', function () {
      buildCounters(false); // muestra el valor final, sin animar
      setupVideos(false);   // videos quietos en su poster
      setStarFinal();       // estrella en su estado ON final
      buildFlavorSwap(false); // imagen fija en el primer sabor
      buildProgress(false);   // barra y cifra en su valor final
    });
  }

  function teardown() {
    clearAccordions();
    clearLines();
    clearVideos();
    clearFlavorSwaps();
    // mm.revert() primero: revierte limpiamente triggers y pins creados en su contexto
    if (mm) { mm.revert(); mm = null; }
    if (ScrollTrigger) ScrollTrigger.getAll().forEach(function (t) { t.kill(); });
  }

  function reinit() {
    teardown();
    init();
    if (ScrollTrigger) ScrollTrigger.refresh();
  }

  /* ---------- Arranque ---------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Recalcular posiciones cuando todo (imagenes/fuentes) haya cargado
  window.addEventListener('load', function () {
    if (ScrollTrigger) ScrollTrigger.refresh();
  });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { if (ScrollTrigger) ScrollTrigger.refresh(); });
  }

  // Editor de temas: reconstruir al cargar/descargar secciones
  document.addEventListener('shopify:section:load', reinit);
  document.addEventListener('shopify:section:unload', reinit);
})();
